// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
  position: fixed;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  padding: 12px 16px;
  background-color: var(--ui-surface);
  border-bottom: 1px solid var(--ui-border);
  box-shadow: var(--ui-shadow-sm);
  z-index: 888;
}

.header .header-left {
    min-width: 220px;
    display: flex;
    align-items: center;
    margin-left: 78px;
  }

.header .header-right {
    display: flex;
    align-items: center;
    gap: 8px;
  }

.header .profile {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
    flex-shrink: 0;

  }

:is(.header .profile)  > h3 {
      color: var(--ui-text);
      font-size: 16px;
      margin: 0;
      line-height: 1;
    }

:is(.header .profile)  > p {
      color: var(--ui-muted);
      font-size: 12px;
      margin: 0;
    }

.header .header-training-badge {
    margin-top: 0;
    padding: 4px 10px;
    border-radius: 999px;
    background: #fff3cd;
    color: #7a5d00;
    border: 1px solid #ffe08a;
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.2px;
    text-transform: uppercase;
    line-height: 1.4;
    max-width: 260px;
    text-align: center;
  }

:is(.header .header-unit-switcher)  > select {
      width: 122px;
      height: 28px;
      border: 1px solid #d7dfed;
      border-radius: 8px;
      background: #f8fafd;
      color: #4c5a70;
      padding: 0 6px;
      font-size: 11px;
      line-height: 1;
      transition: border-color 0.2s ease, background-color 0.2s ease;
    }

:is(.header .header-unit-switcher)  > select:focus {
      outline: none;
      border-color: #9bb2da;
      background: #fff;
    }

.header button {
    background: none;
    color: var(--ui-primary);
    border: none;
    padding: 6px 8px;
    border-radius: 10px;
  }

:is(.header button)  > img {
      width: 22px;
    }

.header button:hover {
    background: rgba(3, 78, 162, 0.08);
  }

.sidebar.open ~ .header .header-left {
  margin-left: 260px;
}

@media (max-width: 800px) {
    .header .header-left {
      min-width: 160px;
      margin-left: 0;
    }
      :is(.header .header-unit-switcher)  > select {
        width: 104px;
      }

    .header .header-training-badge {
      max-width: 160px;
      font-size: 9px;
      padding: 3px 8px;
    }

  .sidebar.open ~ .header .header-left {
    margin-left: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/header/header.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,WAAW;EACX,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,mCAAmC;EACnC,yCAAyC;EACzC,+BAA+B;EAC/B,YAAY;AAwFd;;AAtFE;IACE,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,iBAAiB;EACnB;;AAEA;IACE,aAAa;IACb,mBAAmB;IACnB,QAAQ;EACV;;AAEA;IACE,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,QAAQ;IACR,cAAc;;EAehB;;AAbE;MACE,qBAAqB;MACrB,eAAe;MACf,SAAS;MACT,cAAc;IAChB;;AAEA;MACE,sBAAsB;MACtB,eAAe;MACf,SAAS;IACX;;AAIF;IACE,aAAa;IACb,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;EACpB;;AAGE;MACE,YAAY;MACZ,YAAY;MACZ,yBAAyB;MACzB,kBAAkB;MAClB,mBAAmB;MACnB,cAAc;MACd,cAAc;MACd,eAAe;MACf,cAAc;MACd,8DAA8D;IAChE;;AAEA;MACE,aAAa;MACb,qBAAqB;MACrB,gBAAgB;IAClB;;AAGF;IACE,gBAAgB;IAChB,wBAAwB;IACxB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;EAIrB;;AAHE;MACE,WAAW;IACb;;AAGF;IACE,kCAAkC;EACpC;;AAGF;EACE,kBAAkB;AACpB;;AAEA;IAEI;MACE,gBAAgB;MAChB,cAAc;IAChB;MAGE;QACE,YAAY;MACd;;IAGF;MACE,gBAAgB;MAChB,cAAc;MACd,gBAAgB;IAClB;;EAIF;IACE,cAAc;EAChB;AACF","sourcesContent":[".header {\n  position: fixed;\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 16px;\n  background-color: var(--ui-surface);\n  border-bottom: 1px solid var(--ui-border);\n  box-shadow: var(--ui-shadow-sm);\n  z-index: 888;\n\n  .header-left {\n    min-width: 220px;\n    display: flex;\n    align-items: center;\n    margin-left: 78px;\n  }\n\n  .header-right {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n  }\n\n  .profile {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 4px;\n    flex-shrink: 0;\n\n    >h3 {\n      color: var(--ui-text);\n      font-size: 16px;\n      margin: 0;\n      line-height: 1;\n    }\n\n    >p {\n      color: var(--ui-muted);\n      font-size: 12px;\n      margin: 0;\n    }\n\n  }\n\n  .header-training-badge {\n    margin-top: 0;\n    padding: 4px 10px;\n    border-radius: 999px;\n    background: #fff3cd;\n    color: #7a5d00;\n    border: 1px solid #ffe08a;\n    font-size: 10px;\n    font-weight: 700;\n    letter-spacing: 0.2px;\n    text-transform: uppercase;\n    line-height: 1.4;\n    max-width: 260px;\n    text-align: center;\n  }\n\n  .header-unit-switcher {\n    >select {\n      width: 122px;\n      height: 28px;\n      border: 1px solid #d7dfed;\n      border-radius: 8px;\n      background: #f8fafd;\n      color: #4c5a70;\n      padding: 0 6px;\n      font-size: 11px;\n      line-height: 1;\n      transition: border-color 0.2s ease, background-color 0.2s ease;\n    }\n\n    >select:focus {\n      outline: none;\n      border-color: #9bb2da;\n      background: #fff;\n    }\n  }\n\n  button {\n    background: none;\n    color: var(--ui-primary);\n    border: none;\n    padding: 6px 8px;\n    border-radius: 10px;\n    >img {\n      width: 22px;\n    }\n  }\n\n  button:hover {\n    background: rgba(3, 78, 162, 0.08);\n  }\n}\n\n.sidebar.open ~ .header .header-left {\n  margin-left: 260px;\n}\n\n@media (max-width: 800px) {\n  .header {\n    .header-left {\n      min-width: 160px;\n      margin-left: 0;\n    }\n\n    .header-unit-switcher {\n      >select {\n        width: 104px;\n      }\n    }\n\n    .header-training-badge {\n      max-width: 160px;\n      font-size: 9px;\n      padding: 3px 8px;\n    }\n\n  }\n\n  .sidebar.open ~ .header .header-left {\n    margin-left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
